import { Subject } from 'rxjs';

export class SearchingEventEmitter extends Subject<any>{
    constructor() {
        super();
    }
    emit(value) { super.next(value); }
}